var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parameter-group"},[_c('info-item',{attrs:{"name":_vm.title,"value":"Value","title":"","nomarker":"","noline":""}}),_vm._l((_vm.infos),function(ref,index){
var label = ref.label;
var value = ref.value;
return _c('info-item',{key:("vv-" + index),attrs:{"name":label,"value":value,"noline":"","nomarker":""}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }